import ChipSettings from "./ChipSettings";

export default ChipSettings;